import React from 'react';
import { Box, Modal, Card, CardContent, CardHeader, Stack, Button, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-fetching-library';
import { updateOrder } from '../../../../services/redux-actions';
import { updateProductAction } from '../../../../services/request';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const EditPositionModal = ({ open, handleClose, position, order, formik, module }) => {
  const dispatch = useDispatch();
  const { loading, mutate } = useMutation(updateProductAction);
  const [amount, setAmount] = React.useState(position.gross_value);
  const [name, setName] = React.useState(position.name);

  const handleChange = e => setAmount(e.target.value);
  const handleChangeName = e => setName(e.target.value);

  const handleSubmit = async () => {
    if (amount !== '' && name.trim() !== '') {
      if (module !== 'zielone_szkoly') {
        formik.setFieldValue('positions', formik.values.positions.map(p => {
          if (p.id === position.id) {
            if (p.status === 'NEW') {
              return { ...p, gross_value: amount, name };
            }

            return { ...p, status: 'EDITED', gross_value: amount, name };

          }

          return p;
        }));
        handleClose();
      } else {
        const data = {
          gross_value: amount,
          name
        };

        const { error } = await mutate(position.id, data);

        if (!error) {
          dispatch(updateOrder({ ...order, products: order.products.map(product => {

            if (product.id === position.id) {
              return { ...product, gross_value: amount, name };
            }

            return product;

          }) }));
          toast.success('Pozycja została zaktualizowana');
          handleClose();
        } else {
          toast.error('Wystąpił błąd');
        }
      }


    }

  };

  return (<>
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Card sx={{ ...style }}>
        <CardHeader title="Edytuj wartość pozycji"/>
        <CardContent sx={{ flexGrow: 1, width: '400px' }}>
          <TextField
            label={'Nazwa'}
            fullWidth
            onChange={handleChangeName}
            value={name}
          />
          <Box height={40} />
          <TextField
            label={'Kwota (zł)'}
            fullWidth
            type="number"
            onChange={handleChange}
            value={amount}
          />
          <Box height={40} />
          <Stack flexDirection="row" justifyContent="space-around">
            <Button sx={{ flexGrow: 0.4 }} variant="outlined" onClick={handleClose}>anuluj</Button>
            <Button sx={{ flexGrow: 0.4 }} variant="contained" disabled={amount === '' || name.trim() === '' || loading} onClick={handleSubmit}>edytuj</Button>
          </Stack>
        </CardContent>
      </Card>
    </Modal>
  </>);
};

export default EditPositionModal;
